<template>
  <div style="margin-bottom:16px;">
    <a-row :gutter="16">
      <a-col :span="11">
        <a-card title="企业涉诉案件统计" :bordered="false">
          <v-chart :options="option1" />
        </a-card>
      </a-col>
      <a-col :span="11">
        <a-card title="企业历年涉诉案件统计" :bordered="false">
          <v-chart :options="option234.option2" />
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :span="12">
        <a-card title="每年被执行人个数统计" :bordered="false">
          <v-chart :options="option234.option3" />
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="每年执行标的总额统计" :bordered="false">
          <v-chart :options="option234.option4" />
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import './config'
export default {
  props: ['judicialStatistics', 'judicialStatisticsByYear'],
  components: {
    'v-chart': ECharts,
  },
  data() {
    return {
      option4: {},
      JUDICIAL_KEY_NAME1: {
        ygzs: '原告',
        bgzs: '被告',
        dsrcnt: '第三人',
        ssrcnt: '上诉人',
        bssrcnt: '被上诉人',
        zssqrcnt: '再审申请人',
        sqzxrcnt: '申请执行人',
        bzxrcnt: '被执行人',
        bsqrcnt: '被申请人',
        qtcnt: '其他',
      },
      mnbzxrcntList: [],
    }
  },
  mounted() {
    // this.getLineData()
  },
  computed: {
    option1: function() {
      let option1 = {}
      if (this.judicialStatistics) {
        var result = this.keyValueName(
          this.judicialStatistics,
          this.JUDICIAL_KEY_NAME1,
        )
        option1 = {
          title: {
            text: '某站点用户访问来源',
            subtext: '纯属虚构',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)',
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: [
              '原告',
              '被告',
              '第三人',
              '上诉人',
              '被上诉人',
              '再审申请人',
              '申请执行人',
              '被执行人',
              '被申请人',
              '其他',
            ],
          },
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: result,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
            },
          ],
        }
      }
      return option1
    },
    option234: function() {
      let option2 = {}
      let option3 = {}
      let option4 = {}
      var nfList = [],
        mnajzsList = [],
        mnygzsList = [],
        mnbgzsList = [],
        mnbzxrcntArr = [],
        mnbdzeList = []
      if (this.judicialStatisticsByYear.length > 0) {
        this.judicialStatisticsByYear.map(item => {
          const { nf, mnajzs, mnygzs, mnbgzs, mnbzxrcnt, mnbdze } = item
          nfList.push(Number(nf))
          mnajzsList.push(Number(mnajzs))
          mnygzsList.push(Number(mnygzs))
          mnbgzsList.push(Number(mnbgzs))
          mnbzxrcntArr.push(Number(mnbzxrcnt))
          mnbdzeList.push(Number(mnbdze))
        })

        var result2 = [
          {
            name: '涉诉案件',
            type: 'line',
            data: mnajzsList,
          },
          {
            name: '原告案件',
            type: 'line',
            data: mnygzsList,
          },
          {
            name: '被告案件',
            type: 'line',
            data: mnbgzsList,
          },
        ]

        let result3 = [
          {
            name: '每年被执行人个数统计',
            type: 'line',
            data: mnbzxrcntArr,
          },
        ]

        let result4 = [
          {
            name: '每年执行标的总额统计',
            type: 'line',
            data: mnbdzeList,
          },
        ]
        //企业历年涉诉案件统计_option
        option2 = {
          title: {
            text: '折线图堆叠',
          },
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ['涉诉案件', '原告案件', '被告案件'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: nfList,
          },
          yAxis: {
            type: 'value',
          },
          series: result2,
        }
        //每年被执行人个数统计_option
        option3 = {
          title: {
            text: '折线图堆叠',
          },
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ['被执行人个数'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: nfList,
          },
          yAxis: {
            type: 'value',
          },
          series: result3,
        }
        //每年执行标的总额统计_option
        option4 = {
          title: {
            text: '折线图堆叠',
          },
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ['被执行人个数'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: nfList,
          },
          yAxis: {
            type: 'value',
          },
          series: result4,
        }
      }
      return {
        option2: option2,
        option3: option3,
        option4: option4,
      }
    },
  },
  methods: {
    keyValueName(keyValue, keyName) {
      var result = []
      for (var key in keyValue) {
        for (var key2 in keyName) {
          if (key == key2) {
            result.push({
              value: Number(keyValue[key]),
              name: keyName[key2],
            })
          }
        }
      }
      return result
    },
  },
}
</script>
